import { SvgIcon } from "@mui/material";

export function HelpIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
      }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5215 21H14.4844"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5215 3H14.4844"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 13.9815V10.0195"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 13.9815V10.0195"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7656 16.5352V16.579"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7634 13.8942C12.7761 12.929 11.8984 12.5194 11.2456 12.1477C10.4497 11.7089 9.91065 11.0103 9.91065 10.0412C9.91065 8.60513 11.0714 7.45312 12.4978 7.45312C13.9339 7.45312 15.0859 8.60513 15.0859 10.0412"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4766 16.9141C21.1642 19.147 19.6824 20.7174 17.43 20.9801"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60938 20.9801C5.35687 20.7164 3.88477 19.147 3.57247 16.9141"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4766 7.09532C21.1642 4.86234 19.6824 3.28321 17.43 3.01953"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60938 3.01953C5.35687 3.28321 3.88477 4.86234 3.57247 7.09532"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
